import type { OrderStage } from '@/components/order/pharmacy-order-details/PharmacyOrderDetails';
import { Step, StepLabel, Stepper } from '@montugroup/design-system';
import { styled } from '@mui/material/styles';

export type OrderStatusStepperProps = {
  stage: OrderStage;
};

export type Props = OrderStatusStepperProps & {
  isClickAndCollect: boolean;
};

const StyledStep = styled(Step)(({ theme }) => ({
  '& .MuiStepLabel-root .Mui-completed svg': {
    color: `${theme.palette.success.main}`,
  },
}));

const ShippedOrderStagesInOrder = ['orderPlaced', 'shippedByPharmacy', 'delivered'];
const ClickAndCollectOrderStagesInOrder = ['orderPlaced', 'readyForCollection', 'collected'];

const ClickAndCollectOrderStepper = ({ stage }: OrderStatusStepperProps) => {
  const stepperIndex = ClickAndCollectOrderStagesInOrder.indexOf(stage);
  return (
    <Stepper activeStep={stepperIndex} orientation="vertical">
      <StyledStep key="OrderPlaced" completed={stepperIndex >= 0}>
        <StepLabel>Order placed</StepLabel>
      </StyledStep>
      <StyledStep key="ReadyForCollection" completed={stepperIndex >= 1}>
        <StepLabel>Ready for collection</StepLabel>
      </StyledStep>
      <StyledStep key="Collected" completed={stepperIndex >= 2}>
        <StepLabel>Collected</StepLabel>
      </StyledStep>
    </Stepper>
  );
};

const ShippedOrderStepper = ({ stage }: OrderStatusStepperProps) => {
  const stepperIndex = ShippedOrderStagesInOrder.indexOf(stage);
  return (
    <Stepper activeStep={stepperIndex} orientation="vertical">
      <StyledStep key="OrderPlaced" completed={stepperIndex >= 0}>
        <StepLabel>Order placed</StepLabel>
      </StyledStep>
      <StyledStep key="ShippedByPharmacy" completed={stepperIndex >= 1}>
        <StepLabel>Shipped by pharmacy</StepLabel>
      </StyledStep>
      <StyledStep key="Delivered" completed={stepperIndex >= 2}>
        <StepLabel>Delivered</StepLabel>
      </StyledStep>
    </Stepper>
  );
};

function OrderProgressStepper({ stage, isClickAndCollect }: Props) {
  if (isClickAndCollect) {
    return <ClickAndCollectOrderStepper stage={stage} />;
  }
  return <ShippedOrderStepper stage={stage} />;
}

export default OrderProgressStepper;
